
export const solutions = {
  '1gb.solutions': '1Gb 솔루션',
  '10gb.solutions': '10Gb 솔루션',
  '1gb.vpx.accessories': '1Gb VPX 액세서리',
  'software': '소프트웨어',
  '1gb.description': '고성능 1Gb AV over IP 솔루션',
  '10gb.description': '초고성능 10Gb AV over IP 솔루션',
  'vpx.accessories.description': '1Gb VPX 솔루션용 필수 액세서리',
  'software.description': 'Aurora IPBaseT Manager 소프트웨어는 Aurora IPBaseT AV over IP 제품의 IPX, VPX 및 VLX 시리즈를 위한 올인원 제어 애플리케이션입니다',
  'avoip.solutions': 'AVOIP 솔루션',
  'choose.network.speed': '선호하는 네트워크 속도를 선택하세요',
  'touch.controllers': '터치 컨트롤러',
  'touch.controllers.description': '원활한 제어를 위한 전문 터치 패널 인터페이스',
  'control.processors': '제어 프로세서',
  'control.processors.description': '시스템 관리를 위한 고급 제어 프로세서',
  'reax.software': '소프트웨어',
  'reax.software.description': '전문 제어 시스템 개발 소프트웨어',
  'reax.accessories': '액세서리',
  'reax.accessories.description': 'ReAX 시스템용 필수 액세서리',
  'reax.control.solutions': 'ReAX 제어 솔루션',
  'choose.control.solution': '선호하는 제어 솔루션을 선택하세요',
  'digital.signal.processors': '디지털 신호 프로세서',
  'dsps.description': '전문 오디오 처리 솔루션',
  'amplifiers': '앰프',
  'amplifiers.description': '고성능 오디오 증폭',
  'speakers': '스피커',
  'speakers.description': '프리미엄 오디오 재생 솔루션',
  'audio.solutions': '오디오 솔루션',
  'choose.audio.solution': '선호하는 오디오 솔루션을 선택하세요',
};
